var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import Installations from '../apis/installations';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { saveServiceEvent } from '../store/slices/serviceEventSlice';
export default function Banner() {
    var history = useHistory();
    var dispatch = useDispatch();
    function createServiceEvent() {
        return __awaiter(this, void 0, void 0, function () {
            var serviceEvent;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Installations.createServiceEvent({ clientId: 945, serviceId: 3065, programId: 1532 })];
                    case 1:
                        serviceEvent = _a.sent();
                        console.log("new service event " + serviceEvent.serviceEventId + " created");
                        return [4 /*yield*/, dispatch(saveServiceEvent(serviceEvent))];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    function startActivation() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, createServiceEvent()];
                    case 1:
                        _a.sent();
                        history.push('/activation');
                        return [2 /*return*/];
                }
            });
        });
    }
    return (React.createElement("section", { id: "1" },
        React.createElement("div", { className: "section1" },
            React.createElement("div", { className: "bannerMain" },
                React.createElement("div", { className: "bannerContent" }),
                React.createElement("div", { className: "bannerContent grayBG" },
                    React.createElement("img", { alt: "Tempest Logo", src: "img/tempest.png" }),
                    React.createElement("p", null,
                        React.createElement("span", { id: "book", onClick: startActivation }, "BOOK NOW"))))),
        React.createElement("div", { className: "content1" },
            React.createElement("h3", null, "WeatherFlow has partnered with InstallerNet for professional installation"),
            React.createElement("p", null, "InstallerNet has a nationwide network of smart home professionals who can site and install your Tempest Weather System for optimal weather data collection. Only Tempest-trained technicians will come to your home to provide the service. Only approved procedures for configuration and setup, along with proper hardware for mounting your Tempest will be utilized. We feel so strongly about the expertise of our installers we back it up with a Lifetime Labor Warranty on the installation.")),
        React.createElement("div", { className: "clearFix" }),
        React.createElement("div", { className: "arrowBox" })));
}
